__turbopack_context__.v({
  "avatar": "InstagramPost-module-scss-module__2zQdDq__avatar",
  "commentsPlaceholder": "InstagramPost-module-scss-module__2zQdDq__commentsPlaceholder",
  "embedWrapper": "InstagramPost-module-scss-module__2zQdDq__embedWrapper",
  "fallback": "InstagramPost-module-scss-module__2zQdDq__fallback",
  "fallbackBody": "InstagramPost-module-scss-module__2zQdDq__fallbackBody",
  "fallbackButtonWrapper": "InstagramPost-module-scss-module__2zQdDq__fallbackButtonWrapper",
  "fallbackComments": "InstagramPost-module-scss-module__2zQdDq__fallbackComments",
  "fallbackHeader": "InstagramPost-module-scss-module__2zQdDq__fallbackHeader",
  "fallbackLikes": "InstagramPost-module-scss-module__2zQdDq__fallbackLikes",
  "fallbackTitle": "InstagramPost-module-scss-module__2zQdDq__fallbackTitle",
  "followPlaceholder": "InstagramPost-module-scss-module__2zQdDq__followPlaceholder",
  "handlePlaceholder": "InstagramPost-module-scss-module__2zQdDq__handlePlaceholder",
  "headerMeta": "InstagramPost-module-scss-module__2zQdDq__headerMeta",
  "instagramPost": "InstagramPost-module-scss-module__2zQdDq__instagramPost",
  "likesPlaceholder": "InstagramPost-module-scss-module__2zQdDq__likesPlaceholder",
  "namePlaceholder": "InstagramPost-module-scss-module__2zQdDq__namePlaceholder",
});
